<div class="table-responsive" *ngIf="talepler">
  <table class="table card-table table-vcenter datatable">
    <thead>
      <tr>
        <th class="w-1">Talep No</th>
        <th>Talep Tarihi</th>
        <th>Şube Adı</th>
        <th>Talep Türü</th>
        <th>Ürün Grubu</th>
        <th>Durumu</th>
        <th>Talep Oluşturan</th>
        <th *ngIf="!pIsFatura">Teklif İstenen / <br>Teklif Veren</th>
        <th *ngIf="pIsFatura">Cari</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let t of talepler">
        <tr [class]="(t.durum === DURUM_ONAY_SURECI && t.talepOnaySeviye?.kullaniciGrup?.id === userGrupId) ? 'bg-orange text-white' : ''">
          <td><span class="text-muted">{{t.talepNo}}</span></td>
          <td>{{t.olusturmaTarihiText}}</td>
          <td>{{t.sube?.isim}}</td>
          <td>{{t.talepTur?.isim}}</td>
          <td>{{t.urunGrup?.isim}}</td>
          <td>{{t.durumText}}</td>
          <td>{{t.kullanici?.adSoyad}}</td>
          <td *ngIf="!pIsFatura" [class]="pIsTeklif && t.isTeklifFiyatDegisti ? 'alert alert-warning' : ''">{{t.teklifIstenen}} / {{t.teklifVeren}}
            <svg *ngIf="pIsTeklif && t.isTeklifFiyatDegisti" xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
              stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M8.7 3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-4.7 4.7c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l4.7 -4.7c.2 -.2 .4 -.3 .7 -.3z" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </td>
          <td *ngIf="pIsFatura">{{t.cari?.firmaUnvani}}</td>
          <td class="text-right">
            <div class="btn btn-sm btn-success" (click)="incele(t)">İncele</div>
            <div class="ml-3 btn btn-sm btn-danger" *ngIf="this.userGrupId===1 && pIsDeleteButtonShow == true" (click)="talepSil(t)">Sil</div>
            <div class="btn btn-sm btn-primary ml-3" *ngIf="!pIsSiparis && !pIsTalep && !pIsFatura
                                  && ((t.durum === DURUM_TEKLIF_TOPLA || t.talepTur?.id === 1) || isTeklifIstenebilir(t))
                                  && isTeklifIstenebilir(t)" (click)="teklifIste(t)">Teklif İste
            </div>
            <!--&& (t.durum === DURUM_TEKLIF_TOPLA && !isSiparisVerilebilir(t) || t.talepTur?.id === 1) -->
            <!-- *ngIf="(pIsTeklif || pIsTeklifSiparis) && isSiparisVerilebilir(t)" -->
            <div class="btn btn-sm btn-warning ml-3" *ngIf="t.siparisverilebilir"
              (click)="siparisOlustur(t)">Sipariş Oluştur</div>
              <!---->
            <div class="btn btn-sm btn-warning ml-3"
              *ngIf="pIsFatura && t.durum === DURUM_TEKLIF_TOPLA && t.faturaTalepId == -1" (click)="faturaOlustur(t)">
              Fatura
              Oluştur</div>
            <!-- <div class="btn btn-sm btn-danger ml-3" *ngIf="t.durum < DURUM_SIPARIS_OLUSTURULDU && !pIsFatura"
              (click)="iptalEt(t.id)">İptal Et</div> -->
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>